import type { FC } from "react";

import type { UseFormReturn } from "react-hook-form";

import type { RiskTolerance } from "~/v2/api/rest/account";
import { RadiosInput } from "../../RadiosInput";
import type { InvestmentExperience } from "./schema";

const LABEL =
  "Select the degree of risk you're willing to take with the assets in this account.";

const OPTIONS: {
  label: string;
  value: RiskTolerance;
}[] = [
  { label: "Low risk", value: "conservative" },
  { label: "Moderate risk", value: "moderate" },
  { label: "High risk", value: "significant_risk" },
];

type RiskToleranceInputProps = {
  form: UseFormReturn<InvestmentExperience>;
};

export const RiskToleranceInput: FC<RiskToleranceInputProps> = ({ form }) => {
  const {
    setValue,
    formState: { errors },
    watch,
  } = form;

  const riskTolerance = watch("risk_tolerance");

  const errorMessage = errors.risk_tolerance?.message;

  const onClick = (value: string) =>
    setValue("risk_tolerance", value as RiskTolerance);

  return (
    <RadiosInput
      id="risk_tolerance"
      label={LABEL}
      value={riskTolerance}
      options={OPTIONS}
      onSelect={onClick}
      errorMessage={errorMessage}
    />
  );
};
